document.addEventListener("DOMContentLoaded", (event) => {
  gsap.registerPlugin(ScrollTrigger, SplitText);
  let mm = gsap.matchMedia();

  gsap.to('.button.white.text-hover', { 
    opacity: 0, 
    scrollTrigger: { 
      trigger: '.button.white.text-hover', 
      start: 'top bottom-=100', 
      markers: false,
      toggleActions: 'play none none reverse'
    } 
  })

  mm.add("(min-width: 1025px)", () => {
    smoothScroll();
     videoChangeOnScroll();
  });
  mm.add("(max-width: 1024px)", () => {
    videoChangeOnClick();
  });
  


  splitText();
  navColorChangeOnBackground();
  logoColorOnScroll();
  fixedVideoBg();
  playVideoOnSectionEnter();
  productVideo();
 
  
});



function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function splitText(){
  const textHoverElements = gsap.utils.toArray('.text-hover');

textHoverElements.forEach((el) => {
  const originalText = el.textContent.trim();
  el.textContent = ''; // Clear original content
  
  // Create original span
  const originalSpan = document.createElement('span');
  originalSpan.classList.add('original');
  originalSpan.textContent = originalText;
  el.appendChild(originalSpan);
  
  // Create duplicate span
  const duplicateSpan = document.createElement('span');
  duplicateSpan.classList.add('duplicate');
  duplicateSpan.textContent = originalText;
  el.appendChild(duplicateSpan);
  
  // Split both spans
  const originalSplit = new SplitType(originalSpan, {
    type: 'chars',
    tagName: 'span',
    wordClass: 'block',
    charClass: 'letter'
  });
  
  const duplicateSplit = new SplitType(duplicateSpan, {
    type: 'chars',
    tagName: 'span',
    wordClass: 'block',
    charClass: 'letter'
  });
  
  // Add delays to both sets of characters
  originalSplit.chars.forEach((char, i) => {
    char.style.setProperty('--delay', `${0.03 * i}s`);
  });
  
  duplicateSplit.chars.forEach((char, i) => {
    char.style.setProperty('--delay', `${0.03 * i}s`);
  });
  });

}

function logoColorOnScroll() {
  gsap.to(".circle-svg svg path", {
    fill: "#C32026",
    scrollTrigger: {
      trigger: ".logo-animation",
      start: "top+=700 top",
      markers: false,
      toggleActions: "play none none reverse",
    },
  });
}

function playVideoOnSectionEnter(){
  // const videoElem = document.querySelector('.background-video > video')
  // ScrollTrigger.create({
  //   trigger: videoElem,
  //   start: 'top 80%',
  //   markers: true,
  //   once: true,
  //   onEnter: () => videoElem.play(),
  //   onLeave: () => videoElem.play(),
  //   onEnterBack: () => videoElem.pause(),
  //   onLeaveBack: () => videoElem.pause(),
  // });
}

function navColorChangeOnBackground(){
  const sections = gsap.utils.toArray('.background-dark');
  sections.forEach(section =>{
    ScrollTrigger.create({
      trigger: section,
      start: 'top-=10 top',
      end: 'bottom top+=5',
      markers: false,
      onEnter: ()=>{
        gsap.to(['.thb-secondary-area-item', '.thb-full-menu--link', '.thb-secondary-area-item .thb-item-count', '.mobile-toggle'], { color: 'white'})
        gsap.to('.small-12.columns', { borderColor: 'white'})
        gsap.to('.logoimg', { opacity: 0, ease: 'none' })
        gsap.to('.logoimg.logoimg--light', { opacity: 1, ease: 'none' })
      },
      onLeave: ()=>{
        gsap.to(['.thb-secondary-area-item', '.thb-full-menu--link', '.thb-secondary-area-item .thb-item-count', '.mobile-toggle'], { color: 'black'})
        gsap.to('.small-12.columns', { borderColor: 'black'})
        gsap.to('.logoimg', { opacity: 1, ease: 'none' })
        gsap.to('.logoimg.logoimg--light', { opacity: 0, ease: 'none' })
      },
      onEnterBack: ()=>{
        gsap.to(['.thb-secondary-area-item', '.thb-full-menu--link', '.thb-secondary-area-item .thb-item-count', '.mobile-toggle'], { color: 'white'})
        gsap.to('.small-12.columns', { borderColor: 'white'})
        gsap.to('.logoimg', { opacity: 0, ease: 'none' })
        gsap.to('.logoimg.logoimg--light', { opacity: 1, ease: 'none' })
      },
      onLeaveBack: ()=>{
        gsap.to(['.thb-secondary-area-item', '.thb-full-menu--link', '.thb-secondary-area-item .thb-item-count', '.mobile-toggle'], { color: 'black'})
        gsap.to('.small-12.columns', { borderColor: 'black'})
        gsap.to('.logoimg', { opacity: 1, ease: 'none' })
        gsap.to('.logoimg.logoimg--light', { opacity: 0, ease: 'none' })
      },
    })
  })
}

function smoothScroll() {
  const lenis = new Lenis({
    autoRaf: true,
    anchors: true
  });
}

function productVideo() {
  const productVideoContainer = document.querySelector(
    '#shopify-section-template--24258571108631__main-product .video-container video, [id$="__main-product"] .video-container video'
  );

  ScrollTrigger.create({
    trigger: productVideoContainer,
    start: "top top+=100",
    end: "bottom top+=15%",
    markers: false,
    pin:true,
    scrub: true,
  });
}

function fixedVideoBg() {
  const backgroundSection = document.querySelector(
    ".background-video__content-wrap.is-absolute"
  );
  const fixedContainer = document.querySelector(".fixed-container");

  if(!fixedContainer) return
  ScrollTrigger.create({
    trigger: backgroundSection,
    start: "top top",
    end: "bottom top",
    markers: false,
    onEnter: () => {
      fixedContainer.classList.add("release");
    },
    onLeaveBack: () => {
      fixedContainer.classList.remove("release");
    },
  });

  gsap.from(".background-video__content", {
    opacity: 0,
    ease: "none",
    scrollTrigger: {
      trigger: backgroundSection,
      start: "top top",
      end: "center center",
      scrub: true,
      markers: false,
    },
  });

  gsap.from(".background-video__content", {
    yPercent: 50,
    ease: "none",
    scrollTrigger: {
      trigger: backgroundSection,
      start: "top top",
      end: "bottom top",
      scrub: true,
    },
  });
}

function oldvideoChangeOnScroll() {
  const section = document.querySelector(".science-energy-section");
  const container = document.querySelector(".science-energy-columns");
  const boxes = document.querySelectorAll(".science-energy__content-box");
  const videos = gsap.utils.toArray(".science-energy__video");
  videos.forEach((video, index) => {
    video.style.opacity = "0";
    if(index === 0) video.style.opacity = "1";
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      start: "top top",
      end: "+=300%",
      scrub: true,
      pin: section,
      markers: false,
    },
  });

  tl.to(boxes, {stagger: 1,xPercent: 100})
    .to('.science-energy__content-box', {paddingLeft: '16%',paddingRight: '2rem',stagger: 1},"<")
    .to(videos,{opacity: 1,stagger: 1},"<");
}

function videoChangeOnScroll() {
  const section = document.querySelector(".science-energy-section");
  const container = document.querySelector(".science-energy-columns");
  const boxes = document.querySelectorAll(".science-energy__content-box");
  const videos = gsap.utils.toArray(".science-energy__video");

   videos.forEach((video, index) => {
      video.style.opacity = "0";
      if(index === 0) video.style.opacity = "1";
    });
  

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      start: "top-=20% top",
      end: "+=300%",
      scrub: true,
      pin: section,
      markers: false
    },
  });

  boxes.forEach((box, index) => {
  tl.to(box, {
    xPercent: 100,
    backgroundColor: "#C32026",
    color: "#FFFFFF",
    paddingLeft: "16%",
    paddingRight: "2rem",
    duration: 1,
    onStart: () => {
      box.querySelector('.science-energy__content-heading').style.color = '#FFFFFF';
    }
  });

  if (videos[index]) {
    tl.to(videos[index], {
      opacity: 1,
      duration: 0.5
    }, "<");
  }


  if (index > 0) {
    const prev = boxes[index - 1];
    tl.to(prev, {
      backgroundColor: "#F4F4F4",
      color: "#000000",
      paddingLeft: "16%",
      paddingRight: "2rem",
      duration: 0.1,
      onStart: () => {
        prev.querySelector('.science-energy__content-heading').style.color = '#000000';
      }
    }, "<");
  }

  if (index < boxes.length - 1) {
    const next = boxes[index + 1];
    tl.to(next, {
      backgroundColor: "#F4F4F4",
      color: "#000000",
      duration: 0.1,
      onReverseComplete: () => {
        next.querySelector('.science-energy__content-heading').style.color = '#000000';
      }
    }, "<");
  }
});
}



function videoChangeOnClick() {
  const contentBoxes = document.querySelectorAll('.science-energy__content-box');
  const videos = document.querySelectorAll('.science-energy__video');
  
  function setActive(index) {
  contentBoxes.forEach(box => box.classList.remove('active'));
  videos.forEach(video => video.classList.remove('active'));
  
  contentBoxes[index].classList.add('active');
  videos[index].classList.add('active');
  }
  
  setActive(0);
  
  contentBoxes.forEach((box, index) => {
  box.addEventListener('click', () => {
    setActive(index);
  });
  });
}

